import React from 'react'
import "./HomeCustomTextContent.css"
import articles from '../../ArticlesData'
import { useNavigate } from 'react-router-dom'

function HomeCustomTextContent() {

    const navigate = useNavigate()

    const sideCardImgData = [
        {
            title:"Religious Belief's Impact On Mental Health",
            para:'Lorem ipsum dolor sit amet, consectetuer adipiscing elit.',
            img:"/images/creatives/home-vid-card-1.jpg"
        },
        {
            title:"Teletherapy's Advantages: Counseling At I lome",
            para:'Lorem ipsum dolor sit amet, consectetuer adipiscing elit.',
            img:"/images/creatives/home-vid-card-2.jpg"
        },
        {
            title:"Religious Belief's Impact On Mental Health",
            para:'Lorem ipsum dolor sit amet, consectetuer adipiscing elit.',
            img:"/images/creatives/home-vid-card-3.jpg"
        },
    ]

  const convertToSlug = (str) => {
    return str.toLowerCase().replace(/\s+/g, "-");
  };

  const redirectUserToBlog = (id) => {
    if (!id) return;
    let slug = convertToSlug(id);
    navigate(`/article/${slug}`);

  };

  function truncateText(text, maxLength) {
  if (text.length <= maxLength) {
    return text;
  } else {
    return text.substring(0, maxLength - 3) + '...';
  }
}
  return (
    <div className='HomeCustomTextContent-container standard-padding-space'>
        <div className='container mt-4'>
            <div className='text-content text-lg-start text-center'>
                <h3 className='main-heading'>A <span className='blue-txt'>Legacy</span> of Exceptional Executive <span className='blue-txt'>Care</span> </h3>
                <p className='body-paragraph'>Since our founding, The Toronto Clinic has set the benchmark in personalized, proactive executive health management, earning the trust of leaders from renowned corporations and industries.</p>
            </div>
            <div className='row gy-lg-0 gy-4'>
                <div className='col-lg-6 small-right-gradient-center text-lg-start text-center'>

                    {/* <div className='video-container'> */}
                        {/* <video className='video-container' loop autoPlay muted>
                            <source src="https://videos.pexels.com/video-files/855507/855507-sd_640_360_25fps.mp4" type="video/mp4" />
                            Your browser does not support the video tag.
                        </video> */}
                        {/* <img className='video-container' src='/images/creatives/first-blog.gif'/> */}
                        <img className='video-container video-container-first' src={articles[7].blog_creative} alt='blog thumbnail'/>
                            
                    {/* </div> */}

                    {/* <h3 className='body-heading mt-4'>Recognizing & Managing Bipolar Disorder</h3> */}
                    {/* <p className='body-paragraph bg-none'>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, </p> */}

                    {/* <h3 className='body-heading mt-4'>{articles[0]?.main_heading}</h3>
                    <p className='body-paragraph bg-none'>{articles[0]?.paragraph}</p> */}

                    {/* <p className='body-paragraph bg-none'>An interdisciplinary group at UHN that was responsible for creating and launching the patient monitoring innovation called H.A.L.O. (Human Attended Live Observation) has won the hospital's Mission of Excellence Team Inventor of the Year Award. Pictured are H.A.L.O. clinical inven- tors and co-founders, Marijana Zubrinic and Dr. Shaf Keshavjee.</p> */}

                    <button className='genral-btn mt-3' onClick={()=>{redirectUserToBlog(articles[7]?.slug_url)}}>Learn more</button>
                </div>

                <div className='col-lg-6'>
                    {
                        articles.slice(1,4).map((ele)=>{
                            return(
                                <div className='singleVideo-card d-flex flex-lg-row flex-column align-items-center gap-4 mb-4 pb-2'>
                                    <img src={ele.blog_creative} alt='thumbnail' className='side-card-img' />
                                    <div className='content text-lg-start text-center'>
                                        <h3 className='body-heading' style={{fontSize:"24px"}}>{ele.main_heading}</h3>
                                        <p className='body-paragraph'>{truncateText(ele.paragraph,78)}</p>

                                        <p className='color-blue anchor mb-0' style={{textDecoration:"underline"}} onClick={()=>{redirectUserToBlog(ele.slug_url)}}>Learn more</p>
                                        {/* <button className='genral-btn mb-0'>Learn More</button> */}
                                    </div>
                                </div>
                            )
                        })
                    }

                </div>

            </div>

        </div>
    </div>
  )
}

export default HomeCustomTextContent